import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import Button from "../shared/button/Button";
import labels from "./labels";
import Saving from "../shared/loaders/Saving";
import {
  RejectWrapper,
  Modal,
  Title,
  CloseButton,
  Inner,
  Form,
  Label,
  TextInput,
  ButtonsWrapper,
  Field,
  Error,
} from "./styles/reject-form-styles";

library.add(faTimes, faCheck);

const RejectForm = (props) => {
  const {
    closeRejectModal,
    handleRejectOnSubmit,
    setRejectMessage,
    formLoading,
    errors,
  } = props;

  return (
    <RejectWrapper>
      <Modal>
        <Title>
          Reject Engagement
          <CloseButton onClick={(e) => closeRejectModal(e)}>
            <FontAwesomeIcon icon="times" />
          </CloseButton>
        </Title>
        <Inner>
          {formLoading && <Saving white />}
          <Form onSubmit={handleRejectOnSubmit}>
            <Label>{Parser(labels.reject)}</Label>
            <Field>
              <TextInput
                data-test-id="reject_engagement_message"
                placeholder="Enter your message..."
                onChange={setRejectMessage}
              />
              {errors.rejected_message && (
                <Error>{`Message ${errors.rejected_message}.`}</Error>
              )}
            </Field>
            <ButtonsWrapper>
              <Button
                secondary
                buttonName="Cancel"
                onClickAction={(e) => closeRejectModal(e)}
              />
              <Button primary buttonName="Reject" type="submit" />
            </ButtonsWrapper>
          </Form>
        </Inner>
      </Modal>
    </RejectWrapper>
  );
};

RejectForm.propTypes = {
  closeRejectModal: PropTypes.func.isRequired,
  handleRejectOnSubmit: PropTypes.func.isRequired,
  setRejectMessage: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    rejected_message: PropTypes.string,
  }).isRequired,
};

export default RejectForm;
